import "@coreapp/utils/Polyfill";
import ReactDOM from "react-dom/client";
import { initializeCore, initOrgChartNowApp } from "@coreapp/main";
import { startBlockedFieldObserver } from "@coreapp/utils/blockedFieldObserver";
import App from "./App";
import { waitForElement } from "./Utils/waitForElement";
import { gWhiteLabel } from "@coreapp/whitelabel/brand";
import { enumBrand } from "@coreapp/constants";
import { Globals } from "@coreapp/CoreApp/Globals";

initializeCore().then(async () => {
  if (gWhiteLabel === enumBrand.isolved) {
    try {
      await import("./appComponents/styles/themes/isolved-theme.scss");
      document.getElementById("root")?.classList.add("theme-isolved");
    } catch (error) {
      console.error("Failed to load isolved theme:", error);
    }
  }

  Globals._accountInfo?.CaptureLaunchURL();

  // First create React root and render
  const appRoot = document.getElementById("root")!;
  const root = ReactDOM.createRoot(appRoot);
  root.render(<App />);

  // Dev-mode safety net: warn on raw __blocked__ sentinel in DOM
  startBlockedFieldObserver();

  // Then initialize OrgChart
  await waitForElement(() => document.getElementById("basecanvas"));
  initOrgChartNowApp("dynamic", null);
});
